import { CodeLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { useExportAsXml } from '@/hooks'
import { ExportItem } from '../ExportItem'

interface Props {
  exportable: boolean
}

export const ExportXml: React.FC<Props> = ({ exportable }) => {
  const onClick = useExportAsXml(true)

  return (
    <ExportItem
      label="XML"
      exportable={exportable}
      icon={CodeLight}
      onClick={onClick}
    />
  )
}
